import { useEffect } from 'react'
import i18n from 'i18n'
import { useUserSettings } from 'hooks/useUserSettings'

const LanguageManager = () => {
  const { language } = useUserSettings()

  useEffect(() => {
    if (language && i18n.language !== language) {
      i18n.changeLanguage(language)
    }
  }, [language])

  return null
}

export default LanguageManager
